const IMAGE_BASE_URL = "https://pathrade-prod.s3.ap-northeast-2.amazonaws.com/";

// API가 절대 URL과 S3 상대 키를 섞어 내려주므로 표시 직전에 보정한다.
export function resolveImageUrl(path?: string | null): string {
  if (!path) {
    return "";
  }
  if (/^(https?:)?\/\//.test(path) || path.startsWith("/")) {
    return path;
  }
  return `${IMAGE_BASE_URL}${path}`;
}
